import hellojs from '../../vendor/hello.js'

export default function () {
  return hellojs
    // install Box driver
    .init({
      box: {
        name: 'Box',

        oauth: {
          version: 2,
          auth: 'https://app.box.com/api/oauth2/authorize',
          grant: 'https://app.box.com/oauth2/token',
          response_type: 'code',
        },

        base: 'https://api.box.com/2.0/',

        login(p) {
          // sets popup size to fit the Clio login screen
          p.options.popup.width = 740;
          p.options.popup.height = 640;
        },
      }
    })

    // Initialize Driver instance
    .init(
      { box: window.Drupal.settings.INTEGRATIONS_BOX_APP_ID },
      {
        redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
        oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
      }
    )('box'); // spawn an instance of the driver that one can call .login() on
}


// WEBPACK FOOTER //
// ./src/Integrations/connections/BoxAuthenticator.js